import { render, staticRenderFns } from "./close-button.vue?vue&type=template&id=72990ce6&"
import script from "./close-button.vue?vue&type=script&lang=ts&"
export * from "./close-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports